// Beneficiary Reducer
const beneficiaryChargedDefaultState = {
  idBeneficiaire: '',
  nom: '',
  prenom: '',
  dateNaissance: '',
  email: '',
  autorisationEmailMaf: false,
  displayConnexion :  true,
  lastSuccessLogin : '',
  lastFailLogin : ''

};

export default (state = beneficiaryChargedDefaultState, action) => {
  switch (action.type) {
      case 'SET_BENEFICIARY':
          return {
              ...state,
              ...action.data
          };
      default:
          return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/deneficiary.js